import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {ComplianceStandardResponse} from 'src/api/ProactApiClient';
import {ComplianceStandardTypeEnum} from 'src/api/ProactApiClient';
import {Pill} from 'src/design/atoms/Pill';
import {ActiveInactivePills} from 'src/shared/constants/PillConstants';
import {ComplianceStandardTypeDataOptions} from 'src/shared/constants/columnFilterData';

export const useInstanceComplianceStandardColumns = () => {
  const columns = useMemo<MRT_ColumnDef<ComplianceStandardResponse>[]>(
    () => [
      {
        accessorKey: 'active',
        header: 'Active',
        enableColumnFilter: false,
        enableColumnFilterModes: false,
        Cell: ({cell}) => {
          const cellValue =
            cell.row.original?.instanceComplianceStandards?.at(0)?.active ??
            false;
          const pillConfig = ActiveInactivePills(cellValue);
          return <Pill text={pillConfig.text} color={pillConfig.color} />;
        },
      },
      {
        accessorKey: 'type',
        header: 'Type',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: ComplianceStandardTypeDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<ComplianceStandardTypeEnum>();
          return <>{ComplianceStandardTypeEnum[cellValue]}</>;
        },
      },
      {
        accessorKey: 'sectionLabel',
        header: 'Standard',
      },
      {
        accessorKey: 'summary',
        header: 'Summary',
        Cell: ({cell}) => {
          const cellValue =
            cell.row.original?.instanceComplianceStandards?.at(0)?.summary;
          return <>{cellValue}</>;
        },
      },
    ],
    []
  );

  return columns;
};
